import { useNavigate, useSearchParams } from "react-router-dom";
import classes from "./SubscriptionPage2.module.css";
import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa6";
import { v4 as uuidv4 } from "uuid";
import SmallLoader from "../../component/SmallLoader";
import { loginApi } from "../../http/http";
import { setUserDetails } from "../../store/slices/userSlice";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

const SubscriptionPage2 = () => {
  const [msisdn, setMsisdn] = useState("");
  const [loading, setLoading] = useState(false);
  const [extRef, setExtRef] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedPack, setSelectedPack] = useState("Daily");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userDetails } = useSelector(state => state?.persisted?.userSlice);

  useEffect(() => {
    if (userDetails?.token) navigate("/home");
  }, [userDetails]);

  useEffect(() => {
    if (searchParams.get("ext_ref")) {
      setExtRef(searchParams.get("ext_ref"));
    } else {
      setSearchParams({ ext_ref: uuidv4() });
    }
  }, [searchParams]);

  const handleFormSubmission = async (e) => {
    e.preventDefault();
    if (msisdn?.trim().length === 0) return;
    try {
      setLoading(true);
      const response = await loginApi("1234");
      console.log(response, "response");
      dispatch(setUserDetails(response?.data));
      setLoading(false);
      toast.success("Login Successfully!");
      navigate("/home");
    } catch (error) {
      setLoading(false);
      toast.error(
        error?.response?.data?.message ||
        error?.response?.message ||
        error?.data?.message ||
        "Something Went Wrong!"
      );
    }
  };

  return (
    <div className={classes.page}>

      {/* ══ LEFT — Brand Hero ══ */}
      <div className={classes.leftPanel}>
        <div className={classes.arcCircle} />

        {/* Logo */}
        <div className={classes.logo}>
          {/* <span className={classes.logoIcon}>⚽</span>
          <span className={classes.logoWordmark}>
            <em>Football</em> Masters
          </span> */}

          <img src="/assets/images/logo.png" alt="football" className={classes.logo_img} />
        </div>

        {/* Hero copy */}
        <p className={classes.heroEyebrow}>Fantasy Football Platform</p>
        <h1 className={classes.heroTitle}>
          Build Your
          <span className={classes.accent}>Dream Team.</span>
        </h1>
        <p className={classes.heroSub}>
          Pick real players, predict match outcomes, climb the leaderboard,
          and win real prizes — every single week.
        </p>

        {/* Feature pills */}
        <div className={classes.pillsRow}>
          <span className={classes.pill}>🏅 Live Scores</span>
          <span className={classes.pill}>📊 Leaderboard</span>
          <span className={classes.pill}>🎯 Predictions</span>
        </div>


        {/* Stats */}
        {/* <div className={classes.statsRow}>
          <div className={classes.stat}>
            <span className={classes.statNum}>2M+</span>
            <span className={classes.statLabel}>Players</span>
          </div>
          <div className={classes.statDivider} />
          <div className={classes.stat}>
            <span className={classes.statNum}>₹50L</span>
            <span className={classes.statLabel}>Prizes Won</span>
          </div>
          <div className={classes.statDivider} />
          <div className={classes.stat}>
            <span className={classes.statNum}>500+</span>
            <span className={classes.statLabel}>Matches</span>
          </div>
        </div> */}
      </div>

      {/* ══ RIGHT — Form ══ */}
      <div className={classes.rightPanel}>
        <div className={classes.formContainer}>

          <h2 className={classes.formTitle}>
            Get <span>Started</span>
          </h2>
          <p className={classes.formSubtitle}>
            Subscribe to unlock all features and start playing today.
          </p>

          {/* Tab toggle */}
          <div className={classes.tabToggle}>
            <button
              type="button"
              className={classes.tab}
              onClick={() => navigate(`/login?ext_ref=${extRef}`)}
            >
              Login
            </button>
            <button type="button" className={`${classes.tab} ${classes.activeTab}`}>
              Subscribe
            </button>
          </div>

          <form onSubmit={handleFormSubmission}>
            {/* Phone */}
            <p className={classes.sectionLabel}>Mobile Number</p>
            <div className={classes.phoneRow}>
              <div className={classes.countryPill}>
                <img src="/assets/images/gabon.png" alt="India" className={classes.flag} />
                <span className={classes.dialCode}>+241</span>
              </div>
              <input
                id="msisdn"
                name="msisdn"
                type="number"
                autoFocus
                onWheel={(e) => e.target.blur()}
                placeholder="Enter phone number"
                className={classes.phoneInput}
                onChange={(e) => setMsisdn(e.target.value)}
                value={msisdn}
              />
            </div>

            {/* Plans */}
            <div className={classes.plansSection}>
              <p className={classes.sectionLabel}>Choose Your Plan</p>
              <div className={classes.plansGrid}>

                {/* Daily */}
                <button
                  type="button"
                  className={`${classes.planCard} ${selectedPack === "Daily" ? classes.selDaily : ""}`}
                  onClick={() => setSelectedPack("Daily")}
                >
                  <span className={classes.planEmoji}>⚡</span>
                  <span className={classes.planName}>Daily Pass</span>
                  <span className={classes.planPrice}>50 CFA / Day</span>
                  <span className={classes.planDesc}>Renews daily</span>
                  <div className={classes.radioRing}>
                    {selectedPack === "Daily" && <FaCheck className={classes.checkIcon} />}
                  </div>
                </button>

                {/* Monthly */}
                <button
                  type="button"
                  className={`${classes.planCard} ${selectedPack === "Monthly" ? classes.selMonthly : ""}`}
                  onClick={() => setSelectedPack("Monthly")}
                >
                  <span className={classes.badge}>Best Value</span>
                  <span className={classes.planEmoji}>🏆</span>
                  <span className={classes.planName}>Weekly Elite</span>
                  <span className={classes.planPrice}>250 CFA / Week</span>
                  <span className={classes.planDesc}>Renews weekly</span>
                  <div className={classes.radioRing}>
                    {selectedPack === "Monthly" && <FaCheck className={classes.checkIcon} />}
                  </div>
                </button>

              </div>
            </div>

            {/* Terms */}
            <div className={classes.termsRow}>
              <input
                type="checkbox"
                id="terms"
                name="Terms & Conditions"
                value="Terms"
                className={classes.termsCheck}
                checked
                readOnly
              />
              <label htmlFor="terms" className={classes.termsText}>
                By subscribing, you agree to our{" "}
                <span className={classes.termsLink}>Terms & Conditions</span>
              </label>
            </div>

            {/* CTA */}
            <button type="submit" disabled={loading} className={classes.ctaBtn}>
              {loading
                ? <SmallLoader style={{ border: "4px solid #0f0e0d" }} />
                : <>⚽ Subscribe Now</>
              }
            </button>
          </form>

              {/* ── Copyright footer ── */}
                    <div className={classes.copyrightFooter}>
                        <div className={classes.copyrightDivider} />
                        <div className={classes.copyrightInner}>
                            <span className={classes.copyrightBadge}>
                                <span className={classes.copyrightBadgeIcon}>⚽</span>
                                Football Masters
                            </span>
                            <p className={classes.copyrightText}>
                                © {new Date().getFullYear()} Rainboo Softmate Pvt Ltd
                            </p>
                            <p className={classes.copyrightSub}>All rights reserved</p>
                        </div>
                    </div>

          {/* Trust strip */}
          {/* <div className={classes.trustStrip}>
            <span className={classes.trustItem}>🔒 Secure Payment</span>
            <span className={classes.trustDot} />
            <span className={classes.trustItem}>✓ Cancel Anytime</span>
            <span className={classes.trustDot} />
            <span className={classes.trustItem}>💬 24/7 Support</span>
          </div> */}

        </div>
      </div>

    </div>
  );
};

export default SubscriptionPage2;